import {Component} from "@angular/core";
import {RouterModule} from "@angular/router";
import { NavbarComponent } from "./components/navbar.component";

@Component({
   standalone: true,
   imports: [RouterModule, NavbarComponent],
   selector: "app-root",
   template: `
      <div class="h-screen overflow-x-hidden">
         <navbar></navbar>
         <router-outlet></router-outlet>
      </div>
   `,
   styles: [],
})
export class AppComponent {
   title = "mfc-credit";
}
